// extracted by css-extract-rspack-plugin
export default {"wrapper":"_269d4b0e","columnOverride":"_c80dbddf"};